var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "scrlWrap"
  }, [_vm._l(_vm.list, function (tag, i) {
    return _vm.viewStatus ? _c('Tag', {
      attrs: {
        "tag": tag
      }
    }) : _vm._e();
  }), !_vm.viewStatus ? _c('dl', {
    staticClass: "noneSrch"
  }, [_c('dt', [_vm._v("검색 결과가 없습니다.")]), _c('dd', [_vm._v("플러스 버튼을 눌러 추가해주세요.")])]) : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }